export default __webpack_public_path__ + "static/media/Portrait_Hex.e536c9ea.svg";